export const validateInputs = (inputs: object): boolean => !Object.values(inputs).filter((input) => !input).length;
